"use client";

import { useAuth } from "@/lib/auth";
import Header from "@/components/layout/Header";
import TopHeader from "@/components/top/TopHeader";

export default function AuthAwareHeader() {
  const { user, loading } = useAuth();

  if (loading) return <TopHeader hideNav />;

  return user ? <Header /> : <TopHeader hideNav />;
}
